import React from 'react';

import * as S from './AlternateRoutesStyle';
import { BaseColumnWrap, FlexItemCenter } from './../common/common.styles';

const AlternateRoutesUI = (props) => {
    const {data,searchedSrcName,searchedDestName,onClickCb,searchedDateHeading} = props;
    if(data && data.length){

        return (
        <S.AlternateRoutes>
            <p className="altrntRoutesHeading">{`Alternate Routes for ${searchedDateHeading}`} </p>
            <p>Buses available from nearby locations</p>
            <ul>
                {data.map(routeInfo=>{
                    const {dest,
                    dest_dist,
                    dest_vid,
                    no_of_bus,
                    src,
                    src_dist,
                    src_vid
                    } = routeInfo;
                   

                    return(
                     <li key={src_vid+dest_vid}>
                        <BaseColumnWrap>
                    <p className="title">{src} <span className="seperator"></span> {dest}</p>
                           {src_dist ?  <p>{`${src} is ${src_dist} kms away from ${searchedSrcName}`}</p> :null}
                            {dest_dist? <p>{`${dest} is ${dest_dist} kms away from ${searchedDestName}`}</p> :null}
                    
                        </BaseColumnWrap>
                        <FlexItemCenter onClick={()=>{
                            onClickCb(routeInfo)
                        }}><a>{`View Buses`}</a> <span className="arrow"></span></FlexItemCenter>
                    </li> 
                            
                    )
                    
                })}
              
            </ul>
        </S.AlternateRoutes>
    );
            }else{
                return null;
            }
};

export default AlternateRoutesUI;
